import { MediaResponseBuilder } from './MediaResponseBuilder';
import { ReplyResponseBuilder } from './ReplyResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class ActivityReviewResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('ActivityReview');
    }
    public withReviewId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['reviewId'] = this.initField(null, args);
        return this;
    }

    public withReviewSource = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['reviewSource'] = this.initField(null, args);
        return this;
    }

    public withAuthorName = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['authorName'] = this.initField(null, args);
        return this;
    }

    public withReviewScore = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['reviewScore'] = this.initField(null, args);
        return this;
    }

    public withTitle = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['title'] = this.initField(null, args);
        return this;
    }

    public withReviewText = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['reviewText'] = this.initField(null, args);
        return this;
    }

    public withReviewDateTime = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['reviewDateTime'] = this.initField(null, args);
        return this;
    }

    public withHelpfulVoteCount = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['helpfulVoteCount'] = this.initField(null, args);
        return this;
    }

    public withIsTranslationRequired = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['isTranslationRequired'] = this.initField(null, args);
        return this;
    }

    public withMedia = (builder: MediaResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['media'] = this.initField(builder, args);
        return this;
    }

    public withReplies = (builder: ReplyResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['replies'] = this.initField(builder, args);
        return this;
    }
}
